import { Store } from 'redux';
import serverVars from 'server-vars';
import { hydrateRoot } from 'react-dom/client';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { sharedLoginCheckSetUp } from '../../authentication/sharedLoginCheck';
import { pdpRespUnavailableLayoutEntry } from '../../pdp/respUnavailable/PdpRespUnavailableLayout';
import { clientRelayEnvironment } from '../../clientRelayEnvironment';
import { ServerVarsContextProvider } from '../../global/ServerVarsContext/ServerVarsContext';
import { DblExternalContextProvider } from 'dibs-buyer-layout/exports/DblExternalContext';
import thunk from 'redux-thunk';

/* Reducers */
import { pdpRespNotificationsReducer as sharedNotificationsReducer } from '../../reducers/pdpRespNotificationsReducer';
import { defaultReducers } from '../../reducers/reducerUtils';

/* Helpers */
import { storePdpVisit } from '../../pdp/PdpSharedNotifications/pdpSharedNotificationHelpers';
import { getItemIdFromUri } from '../../utils/getItemIdFormUri';
import { initSharedDatadogRum, pdpTypes } from 'dibs-buyer-layout/exports/initSharedDatadogRum';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';

import { pageDwellTracker, PAGE_DWELL_TRACKER_STOP_TIMES } from 'dibs-tracking';

/* Notifications */
import { pdpRespNotifications } from '../../pdp/PdpRespNotifications/pdpRespNotifications';

const isPdpRespPreviewPage = serverVars.get('isPdpRespPreviewPage');

const options = {
    autoRunNotificationQueue: !isPdpRespPreviewPage,
    middleware: [thunk],
    notifications: pdpRespNotifications,
    reducers: {
        sharedNotificationsReducer,
        ...defaultReducers,
    },
    state: serverVars.get('reduxState'),
};

const itemId = getItemIdFromUri(location.pathname);
if (itemId) {
    storePdpVisit({ itemId });
}

pageDwellTracker.start(PAGE_DWELL_TRACKER_STOP_TIMES.pdp.resp);

initSharedDatadogRum({ page: PAGE_TYPE.PDP, pageType: pdpTypes.unavailable, device: 'resp' });

initializeDBL(options).then(async ({ store }: { store: Store }) => {
    const { environment, socketListeners } = clientRelayEnvironment(
        serverVars.get('dbl.relayData')
    );
    const jsRoot = document.getElementById('js-root');

    sharedLoginCheckSetUp({ store, environment });

    const { Layout } = await pdpRespUnavailableLayoutEntry({
        environment,
        socketListeners,
        relayVars: serverVars.get('relayVars'),
        locale: serverVars.get('locale'),
        messages: serverVars.get('messages'),
    });

    if (!jsRoot) {
        return;
    }

    hydrateRoot(
        jsRoot,
        <ServerVarsContextProvider
            isMobile={serverVars.get('settings.isMobile')}
            isTablet={serverVars.get('settings.isTablet')}
            isDesktop={serverVars.get('settings.isDesktop')}
            clientConf={serverVars.get('config')}
            localeOrigin={serverVars.get('localeOrigin')}
            isSoldPDPV1Variant={serverVars.get('isSoldPDPV1Variant')}
            isItemTileShorterHeight={serverVars.get('isItemTileShorterHeight')}
        >
            <DblExternalContextProvider store={store}>
                <Layout />
            </DblExternalContextProvider>
        </ServerVarsContextProvider>
    );
});
